(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.menu_items = document.querySelectorAll('.header__inline-menu .mega-menu');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.menu_items.forEach(menu => {
        menu.addEventListener('click', (e) => {
          // e.preventDefault();
          this.header.classList.toggle('active-menu');
        });
      });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > 20) {
        this.header.classList.add('scrolled-past-header');
        this.header.classList.add('scrolled--mobile-header--hidden');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.header.classList.remove('scrolled--mobile-header--hidden');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.header.classList.remove('scrolled--mobile-header--hidden');
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.header.classList.remove('scrolled--mobile-header--hidden');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-now"] && !Shopify.designMode) return;
  try {
    
var form=document.querySelector('#mc-embedded-subscribe-form')
function subscribeHandler(event){
    event.preventDefault()
    event.stopImmediatePropagation()
    // console.log('subscribed')
    document.querySelector('input#signupFormToggler').checked = false
    localStorage.setItem('mailChimpSubscribed', true);
	form.submit()
  }
function subscribeHide(e){
    e.stopImmediatePropagation()
	if (e.target.className=='subscribe--overlay'){
	var checkbox=document.querySelector('input#signupFormToggler')
    checkbox.checked = false
	}
}
function subscribeKeepItClosed(){
    sessionStorage.setItem('mailChimpClosed', true);
}
function subscribeShow(){
	// console.log('2nd stage')
	var checkbox=document.querySelector('input#signupFormToggler')
	// console.log('2.1 stage')
	var notSubscribed=localStorage.getItem('mailChimpSubscribed')==='true'?false:true
	// console.log('2.2 stage')
	var notClosed=sessionStorage.getItem('mailChimpClosed')==='true'?false:true
	// console.log('2.3 stage')
	if (checkbox && notSubscribed && notClosed){
	// console.log('3rd stage')
      checkbox.checked =  notSubscribed
      document.querySelector('input#mc-embedded-subscribe').addEventListener('click',subscribeHandler,false)
      form.addEventListener('submit',subscribeHandler,false)
	  document.querySelector('div.subscribe--overlay').addEventListener('click',subscribeHide,false)
	  checkbox.addEventListener('change',subscribeKeepItClosed,false)
    } else {
	console.warn("checkbox: "+checkbox+ " notSubscribed: "+notSubscribed + " notClosed: "+notClosed)
	}
}

if (!subscribeTypeButton){
window.addEventListener("load", function(event) {
	if (subscribeDelayTime){
	window.setTimeout(subscribeShow,subscribeDelayTime)
	}
})
}

  } catch(e) { console.error(e); }
})();
})();
